export default __webpack_public_path__ + "static/media/15.467fb9b6.svg";